import React, { createContext, useContext, useLayoutEffect, useMemo, useState } from 'react';
import { ThemeProvider } from '@mui/material';
import { createAppTheme, getThemeVariables, THEME_COLORS } from '../theme';
import { customStorage } from '../services/CommonService';

const AppThemeContext = createContext({ themeName: 'daylight', setThemeName: () => {} });
export const useAppTheme = () => useContext(AppThemeContext);
export function AppThemeProvider({ children }) {
    const [themeName, setName] = useState(() => {
        try { const saved = customStorage.persistent.getItem('pwf-theme'); return THEME_COLORS[saved] ? saved : 'daylight'; }
        catch { return 'daylight'; }
    });
    const setThemeName = name => { if (THEME_COLORS[name]) setName(name); };
    const theme = useMemo(() => createAppTheme(themeName), [themeName]);
    useLayoutEffect(() => {
        const variables = getThemeVariables(themeName);
        Object.entries(variables).forEach(([key, value]) => document.documentElement.style.setProperty(`--app-${key}`, value));
        document.documentElement.dataset.theme = themeName;
        document.documentElement.style.colorScheme = theme.palette.mode;
        try { customStorage.persistent.setItem('pwf-theme', themeName); } catch { /* Keep selection in memory if storage is unavailable. */ }
    }, [theme, themeName]);
    return <AppThemeContext.Provider value={{ themeName, setThemeName }}>
        <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </AppThemeContext.Provider>;
}
